// extracted by mini-css-extract-plugin
export default {"model":"Modal_model__QR7GX","active":"Modal_active__Kw2nG","modelContent":"Modal_modelContent__1boz2","modelClose":"Modal_modelClose__mlgTB"};